import script from "./wancheng.vue?vue&type=script&setup=true&lang=js"
export * from "./wancheng.vue?vue&type=script&setup=true&lang=js"

import "./wancheng.vue?vue&type=style&index=0&id=623e72f6&lang=less&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-623e72f6"]])

export default __exports__